import * as yup from 'yup';

/**
 * An ISO date carried as text. Declares the primitive it holds (`dataType: 'date'`) for
 * schema-driven surfaces — grids, forms, the formula vocabulary — without adding
 * validation, a transform, or changing the TypeScript type. Its own module so
 * schemas that common-schema-defs depends on (through the data models) can use it too.
 */
export function isoDateStringField() {
  return yup.string().meta({ dataType: 'date' });
}
